/*
 * Main Script File
 * Author: Mario Jahn
 */

import Glide from "@glidejs/glide";
import ScrollPadlock from "scroll-padlock";

const scrollPadlock = new ScrollPadlock();

/**
 * Clicky Menus v1.2.0
 */

(function() {
	"use strict";

	const ClickyMenus = function(menu) {
		// DOM element(s)
		const container = menu.parentElement;
		let currentMenuItem, i, len;

		this.init = function() {
			menuSetup();
			document.addEventListener("click", closeIfClickOutsideMenu);
			// custom event to allow outside scripts to close submenus
			menu.addEventListener("clickyMenusClose", closeOpenSubmenu);
		};

		/*===================================================
		=            Menu Open / Close Functions            =
		===================================================*/
		function toggleOnMenuClick(e) {
			const button = e.currentTarget;

			// close open menu if there is one
			if (currentMenuItem && button !== currentMenuItem) {
				toggleSubmenu(currentMenuItem);
			}

			toggleSubmenu(button);
		}

		function toggleSubmenu(button) {
			const submenu = document.getElementById(
				button.getAttribute("aria-controls")
			);

			if ("true" === button.getAttribute("aria-expanded")) {
				button.setAttribute("aria-expanded", false);
				submenu.setAttribute("aria-hidden", true);
				currentMenuItem = false;

				/*
				// Remove the click event listener when collapsing
				setTimeout(() => {
					button.removeEventListener("click", navigateToHref);
				}, 100);
				*/
			} else {
				button.setAttribute("aria-expanded", true);
				submenu.setAttribute("aria-hidden", false);
				preventOffScreenSubmenu(submenu);
				currentMenuItem = button;

				/*
				// Check if this is a menu-main__link button
				if (button.classList.contains("menu-main__link")) {
					// Find the sibling .small-mobile__link element
					const smallMobileLink = button.parentElement.querySelector(
						".small-mobile__link"
					);
					if (smallMobileLink) {
						const href = smallMobileLink.getAttribute("href");
						if (href) {
							button.setAttribute("role", "link");
							button.setAttribute("title", "Click to navigate when expanded");
							// Store the href on the button for later use
							button.dataset.href = href;
							// Add new click event listener
							button.addEventListener("click", navigateToHref);
						}
					}
				}*/
			}
		}

		// Separate function for navigation to allow easy removal
		function navigateToHref(e) {
			e.preventDefault();
			window.location.href = this.dataset.href;
		}

		function preventOffScreenSubmenu(submenu) {
			const screenWidth =
				window.innerWidth ||
				document.documentElement.clientWidth ||
				document.body.clientWidth,
				parent = submenu.offsetParent,
				menuLeftEdge = parent.getBoundingClientRect().left,
				menuRightEdge = menuLeftEdge + submenu.offsetWidth;

			if (menuRightEdge + 32 > screenWidth) {
				// adding 32 so it's not too close
				submenu.classList.add("sub-menu--right");
			}
		}

		function closeOnEscKey(e) {
			if (e.key === "Escape") {
				// we're in a submenu item
				if (null !== e.target.closest('ul[aria-hidden="false"]')) {
					currentMenuItem.focus();
					toggleSubmenu(currentMenuItem);

					// we're on a parent item
				} else if ("true" === e.target.getAttribute("aria-expanded")) {
					toggleSubmenu(currentMenuItem);
				}
			}
		}

		function closeIfClickOutsideMenu(e) {
			if (currentMenuItem && !e.target.closest("#" + container.id)) {
				toggleSubmenu(currentMenuItem);
			}
		}

		function closeOpenSubmenu() {
			if (currentMenuItem) {
				toggleSubmenu(currentMenuItem);
			}
		}

		/*===========================================================
		=            Modify Menu Markup & Bind Listeners            =
		=============================================================*/
		function menuSetup() {
			menu.classList.remove("no-js");
			const submenuSelector =
				"clickySubmenuSelector" in menu.dataset ?
				menu.dataset.clickySubmenuSelector :
				"ul";

			menu.querySelectorAll(submenuSelector).forEach((submenu) => {
				const menuItem = submenu.parentElement;

				if ("undefined" !== typeof submenu) {
					const button = convertLinkToButton(menuItem);

					setUpAria(submenu, button);

					// bind event listener to button
					button.addEventListener("click", toggleOnMenuClick);
					menu.addEventListener("keyup", closeOnEscKey);
				}
			});
		}

		/**
		 * Why do this? See https://justmarkup.com/articles/2019-01-21-the-link-to-button-enhancement/
		 *
		 * @param {HTMLElement} menuItem An element representing a link to be converted to a button
		 */
		function convertLinkToButton(menuItem) {
			const link = menuItem.getElementsByTagName("a")[0],
				linkHTML = link.innerHTML,
				linkAtts = link.attributes,
				button = document.createElement("button");

			if (null !== link) {
				// copy button attributes and content from link
				button.innerHTML = linkHTML.trim();
				for (i = 0, len = linkAtts.length; i < len; i++) {
					const attr = linkAtts[i];
					if ("href" !== attr.name) {
						button.setAttribute(attr.name, attr.value);
					}
				}

				menuItem.replaceChild(button, link);
			}

			return button;
		}

		function setUpAria(submenu, button) {
			const submenuId = submenu.getAttribute("id");

			let id;
			if (null === submenuId) {
				id =
					button.textContent.trim().replace(/\s+/g, "-").toLowerCase() +
					"-submenu";
			} else {
				id = submenuId + "-submenu";
			}

			// set button ARIA
			button.setAttribute("aria-controls", id);
			button.setAttribute("aria-expanded", false);

			// set submenu ARIA
			submenu.setAttribute("id", id);
			submenu.setAttribute("aria-hidden", true);
		}
	};

	/* Create a ClickMenus object and initiate menu for any menu with .clicky-menu class */
	document.addEventListener("DOMContentLoaded", function() {
		/*####### ACTIVE CLICKY MENU ON TOUCH DEVICES #######*/
		function isTouchPointer() {
			return matchMedia("(pointer: coarse)").matches;
		}
		const clickyMenu = document.getElementById("clicky-menu");

		if (isTouchPointer()) {
			clickyMenu.classList.add("clicky-menu");
			const menus = document.querySelectorAll(".clicky-menu");

			menus.forEach((menu) => {
				const clickyMenu = new ClickyMenus(menu);
				clickyMenu.init();
			});
		}

		/*const menus = document.querySelectorAll( '.clicky-menu' );

		menus.forEach( ( menu ) => {
			const clickyMenu = new ClickyMenus( menu );
			clickyMenu.init();
		} );*/
	});
})();

(function() {
	"use strict";

	// Utility functions for performance optimization
	window.utils = {
		// Throttle function to limit function calls
		throttle: function(func, limit) {
			let inThrottle;
			return function() {
				const args = arguments;
				const context = this;
				if (!inThrottle) {
					func.apply(context, args);
					inThrottle = true;
					setTimeout(() => (inThrottle = false), limit);
				}
			};
		},

		// Debounce function for resize events
		debounce: function(func, wait) {
			let timeout;
			return function executedFunction(...args) {
				const later = () => {
					clearTimeout(timeout);
					func(...args);
				};
				clearTimeout(timeout);
				timeout = setTimeout(later, wait);
			};
		},

		// Check if element is in viewport (for lazy initialization)
		isInViewport: function(element) {
			const rect = element.getBoundingClientRect();
			return (
				rect.top >= 0 &&
				rect.left >= 0 &&
				rect.bottom <=
				(window.innerHeight || document.documentElement.clientHeight) &&
				rect.right <=
				(window.innerWidth || document.documentElement.clientWidth)
			);
		},
	};

	// Debounced cart updates
	window.utils.debouncedStorage = (function() {
		const pending = new Map();
		return function(key, value, delay = 300) {
			clearTimeout(pending.get(key));
			pending.set(
				key,
				setTimeout(() => {
					try {
						sessionStorage.setItem(key, value);
					} catch (e) {}
					pending.delete(key);
				}, delay)
			);
		};
	})();

	// Initialize critical functionality immediately
	function initCriticalFeatures() {
		/*####### SCROLL PADLOCK TOGGLE #######*/
		const mainMenuState = document.getElementById("main-menu__state");
		const header = document.getElementById("header");
		const body = document.body;
		const menuCloseButton = document.getElementById("menu-close");

		function handleClickOutside(event) {
			if (!header.contains(event.target)) {
				mainMenuState.checked = false;
				body.classList.remove("scroll-padlock-locked");
				document.removeEventListener("click", handleClickOutside);
			}
		}

		function closeMenu() {
			mainMenuState.checked = false;
			body.classList.remove("scroll-padlock-locked");
			document.removeEventListener("click", handleClickOutside);
		}

		function initScrollPadlock() {
			if (!mainMenuState || !header) {
				console.warn(
					"Required elements not found for scroll padlock functionality"
				);
				return;
			}

			if (menuCloseButton) {
				menuCloseButton.addEventListener("click", closeMenu);
			}

			mainMenuState.addEventListener("change", function() {
				if (this.checked) {
					body.classList.add("scroll-padlock-locked");
					requestAnimationFrame(() => {
						document.addEventListener("click", handleClickOutside);
					});
				} else {
					body.classList.remove("scroll-padlock-locked");
					document.removeEventListener("click", handleClickOutside);
				}
			});

			// FacetWP integration
			if (typeof FWP !== "undefined" && FWP.hooks) {
				FWP.hooks.addAction("facetwp/flyout/open", function() {
					body.classList.add("scroll-padlock-locked");
				});

				FWP.hooks.addAction("facetwp/flyout/close", function() {
					body.classList.remove("scroll-padlock-locked");
				});
			}
		}

		initScrollPadlock();

		/*####### SHRINK HEADER - Optimized with throttling #######*/
		class StickyHeader {
			constructor() {
				this.SCROLL_THRESHOLD = 40;
				this.COOLDOWN_PERIOD = 100;
				this.header = document.querySelector("#header");
				this.isSmall = false;
				this.lastStateChange = 0;
				this.init();
			}

			init() {
				if (!this.header) return;

				this.checkHeaderState();

				// throttled scroll handler for better performance
				const throttledCheck = window.utils.throttle(() => {
					requestAnimationFrame(() => this.checkHeaderState());
				}, 16); // ~60fps

				window.addEventListener("scroll", throttledCheck, { passive: true });
			}

			checkHeaderState() {
				const now = performance.now();

				if (now - this.lastStateChange < this.COOLDOWN_PERIOD) {
					return;
				}

				const scrollY = window.scrollY;

				if (scrollY === 0 && this.isSmall) {
					this.isSmall = false;
					this.header.classList.remove("header--small");
					this.lastStateChange = now;
				} else if (!this.isSmall && scrollY > this.SCROLL_THRESHOLD) {
					this.isSmall = true;
					this.header.classList.add("header--small");
					this.lastStateChange = now;
				}
			}
		}

		// Initialize header immediately
		new StickyHeader();
	}

	// Initialize non-critical features with lazy loading
	function initNonCriticalFeatures() {
		/*####### MENU IMAGES HOVER #######*/
		const links = document.querySelectorAll(".menu-main__link");
		const mainImage = document.querySelector(".menu-main__images-main");
		const imageCache = new Map(); // Cache DOM queries

		if (links.length > 0) {
			links.forEach((link) => {
				const imageClass = link.id;

				link.addEventListener(
					"mouseover",
					function() {
						if (mainImage) {
							mainImage.classList.remove("active");
						}

						let image = imageCache.get(imageClass);
						if (!image) {
							image = document.querySelector(
								`#menu-main__images .${imageClass}`
							);
							imageCache.set(imageClass, image);
						}

						if (image) {
							image.classList.add("active");
						}
					}, { passive: true }
				);

				link.addEventListener(
					"mouseout",
					function() {
						if (mainImage) {
							mainImage.classList.add("active");
						}

						const image = imageCache.get(imageClass);
						if (image) {
							image.classList.remove("active");
						}
					}, { passive: true }
				);
			});
		}

		/*####### ANIMATE ACCORDIONS #######*/
		const detailsElements = document.getElementsByTagName("details");

		if (detailsElements.length > 0) {
			const handleSummaryClick = (event) => {
				const summary = event.currentTarget;
				const details = summary.parentElement;
				const content = summary.nextElementSibling;

				if (!content) return;

				if (content.classList.contains("animation")) {
					content.classList.remove("animation", "collapsing");
					void summary.offsetWidth;
					return;
				}

				const onAnimationEnd = (cb) =>
					content.addEventListener("animationend", cb, { once: true });

				requestAnimationFrame(() => content.classList.add("animation"));
				onAnimationEnd(() => content.classList.remove("animation"));

				if (details.hasAttribute("open")) {
					event.preventDefault();
					content.classList.add("collapsing");
					onAnimationEnd(() => {
						details.removeAttribute("open");
						content.classList.remove("collapsing");
					});
				}
			};

			document
				.querySelectorAll("summary")
				.forEach((summary) =>
					summary.addEventListener("click", handleSummaryClick)
				);
		}

		/*####### BEAUTIFY SELECT FIELDS #######*/
		function initNiceSelect() {
			const selectElements = document.querySelectorAll("select.styled-select");
			const selectElementsSearch = document.querySelectorAll(
				"select.styled-select-search"
			);

			if (selectElements.length === 0 && selectElementsSearch.length === 0)
				return;

			const lang = document.documentElement.lang;
			const niceSelectOptions =
				lang === "de-DE" ?
				{
					searchable: true,
					placeholder: "auswählen",
					searchtext: "Suche",
					selectedtext: "ausgewählt",
				} :
				{
					searchable: true,
					searchtext: "Search",
				};

			selectElements.forEach(function(selectElement) {
				if (typeof NiceSelect !== "undefined") {
					NiceSelect.bind(selectElement);
				}
			});

			selectElementsSearch.forEach(function(selectElementSearch) {
				if (typeof NiceSelect !== "undefined") {
					NiceSelect.bind(selectElementSearch, niceSelectOptions);
				}
			});
		}

		// Initialize NiceSelect only when needed
		if ("requestIdleCallback" in window) {
			requestIdleCallback(initNiceSelect);
		} else {
			setTimeout(initNiceSelect, 50); // Reduced fallback
		}

		/*####### GLIDE.JS SLIDER #######*/
		function initSliders() {
			// Regular glide sliders
			if (document.getElementsByClassName("glide").length) {
				const sliders = document.querySelectorAll(".glide");

				sliders.forEach((slider) => {
					const slidesCount = slider.querySelectorAll(".glide__slide").length;

					if (slidesCount <= 1) {
						const bullets = slider.querySelector(".glide__bullets");
						if (bullets) {
							bullets.style.display = "none";
						}
					}

					const conf = {
						type: "carousel",
						animationDuration: 800,
						hoverpause: false,
						gap: 0,
						autoplay: slidesCount > 1 ? 7500 : false,
					};

					try {
						const glide = new Glide(slider, conf);
						glide.mount();

						if (slidesCount <= 1) {
							glide.disable();
						}
					} catch (error) {
						console.error("Error initializing Glide slider:", error);
					}
				});
			}

			// Welten sliders
			if (document.getElementsByClassName("glide-welten").length) {
				const slidersWelten = document.querySelectorAll(".glide-welten");
				const confWelten = {
					type: "carousel",
					animationDuration: 800,
					autoplay: 7500,
					hoverpause: false,
					gap: 0,
				};
				slidersWelten.forEach((item) => {
					try {
						new Glide(item, confWelten).mount();
					} catch (error) {
						console.error("Error initializing Welten slider:", error);
					}
				});
			}

			// Welt sliders
			if (document.getElementsByClassName("glide-welt").length) {
				const slidersWelt = document.querySelectorAll(".glide-welt");
				const confWelt = {
					type: "carousel",
					animationDuration: 800,
					perView: 2,
					hoverpause: false,
					gap: 0,
					breakpoints: {
						480: {
							perView: 1.5,
						},
					},
				};
				slidersWelt.forEach((item) => {
					try {
						new Glide(item, confWelt).mount();
					} catch (error) {
						console.error("Error initializing Welt slider:", error);
					}
				});
			}

			// Products sliders
			if (document.getElementsByClassName("glide-products").length) {
				const slidersProducts = document.querySelectorAll(".glide-products");

				const check_resize = (glide) => {
					const slidesCount = glide.slides_count;
					const perView = glide.settings.perView;

					if (slidesCount === 1) {
						glide
							.update({
								startAt: 0,
								type: "slider",
								bound: true,
								rewind: false,
								hoverpause: false,
								classes: { swipeable: "glide--disabled" },
							})
							.disable();
					} else if (slidesCount <= perView) {
						glide
							.update({
								startAt: 0,
								type: "slider",
								bound: true,
								rewind: false,
								hoverpause: false,
								classes: { swipeable: "glide--disabled" },
								breakpoints: {
									480: { type: "carousel" },
								},
							})
							.disable();
					} else {
						glide.enable();
					}
				};

				slidersProducts.forEach((el) => {
					if (
						!el.querySelector(".glide__track") ||
						!el.querySelector(".glide__slides")
					) {
						console.error("Required Glide.js structure is missing");
						return;
					}

					const slidesCount = el.querySelectorAll(".glide__slide").length;

					try {
						const el_glide = new Glide(el, {
							type: "carousel",
							animationDuration: 1200,
							perView: 3,
							hoverpause: false,
							gap: 0,
							autoplay: slidesCount > 3 ? 5000 : false,
							breakpoints: {
								1029: {
									perView: 2.5,
									autoplay: slidesCount > 2 ? 5000 : false,
								},
								480: {
									perView: 1.5,
									autoplay: slidesCount > 1 ? 5000 : false,
								},
							},
						});

						el_glide.slides_count = slidesCount;
						el_glide.on(
							"resize",
							window.utils.debounce(() => check_resize(el_glide), 250)
						);
						el_glide.mount();
						check_resize(el_glide);
					} catch (error) {
						console.error("Error initializing Products slider:", error);
					}
				});
			}

			// Product slider
			if (document.getElementsByClassName("product-slider").length) {
				const slider = document.querySelector(".product-slider");
				if (!slider) return;

				let glideInstance = null;
				const mediaQuery = window.matchMedia("(max-width: 1030px)");
				const slidesCount = slider.querySelectorAll(".glide__slide").length;

				const initGlide = () => {
					try {
						if (!glideInstance) {
							glideInstance = new Glide(".product-slider", {
								type: "carousel",
								perView: 1,
								gap: 0,
								keyboard: true,
								hoverpause: false,
								animationDuration: 1200,
								animationTimingFunc: "cubic-bezier(0.165, 0.840, 0.440, 1.000)",
								autoplay: slidesCount > 1 ? 7500 : false,
								throttle: 50,
							}).mount();
						}
					} catch (error) {
						console.error("Error initializing Glide:", error);
					}
				};

				const destroyGlide = () => {
					try {
						if (glideInstance) {
							glideInstance.destroy();
							glideInstance = null;
						}
					} catch (error) {
						console.error("Error destroying Glide:", error);
					}
				};

				const handleWindowResize = (e) => {
					if (e.matches) {
						initGlide();
					} else {
						destroyGlide();
					}
				};

				handleWindowResize(mediaQuery);
				mediaQuery.addEventListener("change", handleWindowResize);
			}
		}

		// Initialize sliders with delay for better performance
		if ("requestIdleCallback" in window) {
			requestIdleCallback(initSliders, { timeout: 250 });
		} else {
			initSliders();
		}

		/*####### Scroll Reveal Effects #######*/
		const scrollReveal = (() => {
			const hasIntersectionObserver = "IntersectionObserver" in window;
			const defaultOptions = {
				rootMargin: "-5%",
				threshold: 0,
			};

			const createObserver = (callback, options) => {
				if (!hasIntersectionObserver) return null;

				return new IntersectionObserver(
					(entries, observer) => {
						entries.forEach((entry) => {
							if (!entry.isIntersecting) return;
							callback(entry.target);
							observer.unobserve(entry.target);
						});
					}, { ...defaultOptions, ...options }
				);
			};

			const init = (selector, options = {}, callback) => {
				const elements = Array.from(document.querySelectorAll(selector));
				if (!elements.length) return;

				const handleReveal =
					callback || ((element) => element.classList.add("active"));

				if (!hasIntersectionObserver) {
					elements.forEach(handleReveal);
					return;
				}

				const observer = createObserver(handleReveal, options);
				elements.forEach((element) => observer.observe(element));
			};

			return { init };
		})();

		scrollReveal.init(".scroll-reveal");

		/*####### Mobile search modify z-index #######*/
		const menuSearchMobile = document.querySelector(".menu-search--mobile");
		if (menuSearchMobile) {
			const searchInput = menuSearchMobile.querySelector(
				'input[type="search"]'
			);
			if (searchInput) {
				searchInput.addEventListener(
					"focus",
					function() {
						menuSearchMobile.classList.add("active");
					}, { passive: true }
				);

				searchInput.addEventListener(
					"blur",
					function() {
						menuSearchMobile.classList.remove("active");
					}, { passive: true }
				);
			}
		}

		/*####### Shop filter element height #######*/
		const shopGrid = document.querySelector(".shop__grid");
		const shopAside = document.getElementById("shop__aside");

		if (shopGrid && shopAside) {
			const updateMinHeight = () => {
				const shopGridHeight = shopGrid.offsetHeight;
				shopAside.style.minHeight = shopGridHeight + "px";
			};

			updateMinHeight();

			// Use debounced resize handler
			window.addEventListener(
				"resize",
				window.utils.debounce(updateMinHeight, 250)
			);

			if (typeof FWP !== "undefined" && FWP.hooks) {
				document.addEventListener("facetwp-loaded", updateMinHeight);
			}
		}

		/*####### Welt Oval visibility #######*/
		const mainElement = document.getElementById("welten");
		if (mainElement) {
			const weltElements = document.querySelectorAll("div.welt");

			if (weltElements.length > 0) {
				weltElements.forEach((element) => {
					element.style.opacity = "0";
					element.style.transition = "opacity 0.5s ease-in-out";
				});

				if ("IntersectionObserver" in window) {
					const observer = new IntersectionObserver(
						(entries) => {
							entries.forEach((entry) => {
								if (entry.isIntersecting) {
									weltElements.forEach((element) => {
										element.style.opacity = "0";
									});
									entry.target.style.opacity = "1";
								}
							});
						}, {
							threshold: 0.75,
							rootMargin: "0px",
						}
					);

					weltElements.forEach((element) => {
						observer.observe(element);
					});
				}
			}
		}
	}

	/*####### Lazy load videos #######*/
	/*function initLazyVideos() {
		const lazyVideos = document.querySelectorAll("video.lazy");

		if (lazyVideos.length === 0) return;

		if ("IntersectionObserver" in window) {
			const lazyVideoObserver = new IntersectionObserver(
				(entries, observer) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							const video = entry.target;
							const sources = video.querySelectorAll("source[data-src]");

							sources.forEach((source) => {
								source.src = source.dataset.src;
							});

							video.load();
							video.classList.remove("lazy");
							lazyVideoObserver.unobserve(video);
						}
					});
				}, {
					rootMargin: "50px 0px",
					threshold: 0.1,
				}
			);

			lazyVideos.forEach((lazyVideo) => {
				lazyVideoObserver.observe(lazyVideo);
			});
		}
	}*/

	// Initialize everything when DOM is ready
	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", function() {
			initCriticalFeatures();

			// Delay non-critical features to improve initial load performance
			requestAnimationFrame(() => {
				setTimeout(() => {
					initNonCriticalFeatures();
					//initLazyVideos();
				}, 100);
			});
		});
	} else {
		initCriticalFeatures();
		initNonCriticalFeatures();
		//initLazyVideos();
	}
})();

/*####### REMOVE FAVORITES AFTER THEY ARE CLEARED #######*/
jQuery(document).ready(function($) {
	const favoritesList = $(".woocommerce-favorites-list");

	if (favoritesList.length === 0) return; // Early return if no favorites list

	$(document).on("favorites-cleared", function(event, button) {
		favoritesList.find("li").fadeOut(1200, function() {
			$(this).remove();
			favoritesList.html(
				'<p class="en">You have not saved any favourites yet.</p><p class="de">Du hast noch keine Favoriten gespeichert.</p>'
			);
		});
	});

	$(document).on(
		"favorites-updated-single",
		function(event, favorites, post_id, site_id, status) {
			if (status === "inactive") {
				const $item = $(".woocommerce-favorites-list li.post-" + post_id);
				$item.fadeOut(300, function() {
					$(this).remove();
					if ($(".woocommerce-favorites-list li").length === 0) {
						$(".woocommerce-favorites-list").html(
							'<p class="en">You have not saved any favourites yet.</p><p class="de">Du hast noch keine Favoriten gespeichert.</p>'
						);
					}
				});
			}
		}
	);
});

/*####### CART COUNT (WooCommerce Store API) #######*/
(function($) {
	"use strict";

	const $count = $(".cart-count[data-wc-cart-badge]");
	if (!$count.length) return;

	const CART_COUNT_KEY = "musa_cart_count";
	const CART_COUNT_TS_KEY = "musa_cart_count_ts";
	const CART_COUNT_TTL = 300000; // 5 minutes (increased from 60s for better caching)

	// Debounce function to prevent excessive API calls
	let fetchTimeout = null;

	function debouncedFetch(callback, delay = 300) {
		clearTimeout(fetchTimeout);
		fetchTimeout = setTimeout(callback, delay);
	}

	function readCache() {
		try {
			const stored = sessionStorage.getItem(CART_COUNT_KEY);
			const ts = parseInt(sessionStorage.getItem(CART_COUNT_TS_KEY), 10) || 0;
			return {
				value: stored !== null ? parseInt(stored, 10) || 0 : null,
				fresh: Date.now() - ts < CART_COUNT_TTL,
			};
		} catch (e) {
			return { value: null, fresh: false };
		}
	}

	function writeCache(val) {
		try {
			sessionStorage.setItem(CART_COUNT_KEY, String(val));
			sessionStorage.setItem(CART_COUNT_TS_KEY, String(Date.now()));
		} catch (e) {
			// Silently fail if sessionStorage is unavailable
		}

		// Only write to debounced storage if the utility exists
		if (window.utils && typeof window.utils.debouncedStorage === "function") {
			window.utils.debouncedStorage(CART_COUNT_KEY, String(val));
		}
	}

	function updateCount(val) {
		const currentCount = parseInt($count.attr("data-count"), 10) || 0;

		// Only update DOM if value actually changed (performance optimization)
		if (currentCount !== val) {
			$count.text(val > 0 ? val : "").attr("data-count", val);
		}
	}

	function getCountFromCartTable() {
		let total = 0;
		$(".woocommerce-cart-form .cart_item .qty").each(function() {
			total += parseInt($(this).val(), 10) || 0;
		});
		return total;
	}

	function fetchCountFromStoreApi() {
		// Use WooCommerce Store API (lighter than admin-ajax)
		return fetch("/?rest_route=/wc/store/v1/cart", {
				credentials: "same-origin",
				headers: {
					"Content-Type": "application/json",
				},
			})
			.then((response) => {
				if (!response.ok) throw new Error("Store API unavailable");
				return response.json();
			})
			.then((data) => {
				// Store API returns items_count
				return parseInt(data.items_count, 10) || 0;
			});
	}

	function syncCartCount(force = false) {
		// If on cart page, always use table count (most accurate)
		if ($(".woocommerce-cart").length) {
			const cartCount = getCountFromCartTable();
			updateCount(cartCount);
			writeCache(cartCount);
			return Promise.resolve(cartCount);
		}

		// Try cache first (unless force refresh)
		const cache = readCache();
		if (!force && cache.value !== null && cache.fresh) {
			updateCount(cache.value);
			return Promise.resolve(cache.value);
		}

		// Fetch from API
		return fetchCountFromStoreApi()
			.then((count) => {
				updateCount(count);
				writeCache(count);
				return count;
			})
			.catch((err) => {
				// Fallback to cached value on error
				if (cache.value !== null) {
					updateCount(cache.value);
				}
				console.warn("Cart count sync failed, using cached value:", err);
				return cache.value !== null ? cache.value : 0;
			});
	}

	// Initial sync on page load
	syncCartCount();

	// Sync when tab becomes visible (user returns to tab)
	document.addEventListener("visibilitychange", () => {
		if (document.visibilityState === "visible") {
			// Debounce this to prevent rapid API calls
			debouncedFetch(() => syncCartCount(), 500);
		}
	});

	// Listen to WooCommerce events - debounced to prevent multiple calls
	const refreshEvents =
		"added_to_cart removed_from_cart updated_cart_totals updated_wc_div wc_fragments_refreshed";

	$(document.body).on(refreshEvents, function(e) {
		// Force refresh on these events, but debounce it
		debouncedFetch(() => syncCartCount(true), 200);
	});

	// Handle quantity changes on cart page
	if ($(".woocommerce-cart").length) {
		let quantityChangeTimeout;
		$(document.body).on(
			"change",
			".woocommerce-cart-form input.qty",
			function() {
				clearTimeout(quantityChangeTimeout);
				quantityChangeTimeout = setTimeout(() => {
					const newCount = getCountFromCartTable();
					updateCount(newCount);
					writeCache(newCount);
				}, 100);
			}
		);
	}
})(jQuery);

/*####### AJAX FOR VARIABLE PRODUCTS #######*/
let addToCartInProgress = false;

jQuery(document).on(
	"click",
	".single_add_to_cart_button:not(.disabled)",
	function(e) {
		const $button = jQuery(this);
		const $form = $button.closest("form.cart");
		const $radios = $form.find(
			'.woocommerce-variation-radios input[type="radio"]'
		);

		if (addToCartInProgress) {
			e.preventDefault();
			return false;
		}

		const htmlLang = document.documentElement.lang || "en";
		const currentLang = htmlLang.split("-")[0];

		const errorMessages = {
			de: { pleaseSelect: "Bitte wähle eine Option." },
			en: { pleaseSelect: "Please select an option." },
		};

		// Validation for variable products
		if ($form.hasClass("variations_form")) {
			const pleaseSelect = (errorMessages[currentLang] || errorMessages["en"])
				.pleaseSelect;
			const $variations = $form.find('select[name^="attribute_"]');
			let hasEmptyOptions = false;

			$variations.each(function() {
				if (jQuery(this).val() === "") {
					const attributeName =
						jQuery(this).data("attribute_name") || jQuery(this).attr("name");
					const readableName = attributeName
						.replace("attribute_", "")
						.replace("pa_", "")
						.replace(/-/g, " ");

					jQuery(".woocommerce-error").remove();
					$form.before(
						`<div class="woocommerce-error">${pleaseSelect} ${readableName}</div>`
					);
					hasEmptyOptions = true;
					return false;
				}
			});

			if (hasEmptyOptions) {
				e.preventDefault();
				return false;
			}
		}

		// Set progress state
		addToCartInProgress = true;
		$button.addClass("disabled");
		$radios.prop("disabled", true);

		// Clean up existing handlers
		jQuery(document.body).off(
			"added_to_cart.custom_handler wc_fragments_refreshed.custom_handler wc_fragments_ajax_error.custom_handler"
		);

		// Reset function
		const resetState = () => {
			addToCartInProgress = false;
			$button.removeClass("disabled");
			$radios.prop("disabled", false);
			jQuery(document.body).off(
				"added_to_cart.custom_handler wc_fragments_refreshed.custom_handler wc_fragments_ajax_error.custom_handler"
			);
		};

		// Add event handlers
		jQuery(document.body).on(
			"added_to_cart.custom_handler wc_fragments_refreshed.custom_handler wc_fragments_ajax_error.custom_handler",
			resetState
		);

		// Fallback timeout
		setTimeout(resetState, 10000);

		return true;
	}
);